import { ChangeDetectorRef, Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { Countries } from 'src/app/models/Lookup';
import { LookupsService } from 'src/app/services/lookups.service';
import { OnlynumberDirective } from 'src/app/helpers/onlynumber.directive';

@Component({
  selector: 'app-phone-number',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, NgSelectModule, OnlynumberDirective],
  templateUrl: './phone-number.component.html'
})
export class PhoneNumberComponent implements OnInit {
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() controlName!: string;
  @Input() isSubmitted!: boolean;
  @Input() required = false;
  @Input() disabled!: boolean;
  @Input() minLength: number = 5;
  @Input() maxLength: number = 15;
  @Input() label = this.translate.instant('forms.Phone number');
  @Input() appendToBody = false;

  @Input() selectedCountry!: number | any;
  phoneCountryId!: number | any;
  @Input() phoneNumberValue!: any;

  @Input() isCleared = false;
  @Input() loading = false;
  @Output() valueChanged = new EventEmitter<boolean>();
  @Output() valueRemoved = new EventEmitter<boolean>();
  @Output() inputBlur = new EventEmitter<boolean>();

  isTouched!: boolean;

  countryLoading = false;
  countryList: Countries[] = []

  countryListAllCodes: any = []

  constructor(
    private cdr: ChangeDetectorRef,
    public translate: TranslateService,
    public lookupService: LookupsService
  ) { }
  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    this.getAllCountries();

    if (this.controlName && this.formGroup.controls[this.controlName].value) {
      this.phoneNumberValue = this.formGroup.controls[this.controlName].value;
      this.phoneCountryId = this.selectedCountry;
      this.formGroup.controls[this.controlName].setValue(null);
    }

    this.formGroup.controls[this.controlName].valueChanges.subscribe((data) => {
      setTimeout(() => {
        let ctr = this.formGroup.controls[this.controlName];
        let ctrVal = { countryId: 0, number: '', changed: false };
        this.loading = false;
        if (data) {
          if (typeof ctr.value == 'object') {
            ctrVal.number = ctr.value.number;
            ctrVal.countryId = Number(ctr.value.countryCode);
          } else {
            ctrVal.number = ctr.value;
            ctrVal.countryId = Number(this.selectedCountry);
            ctrVal.changed = true;
          }
        } else {
          ctrVal.number = '';
          ctrVal.countryId = this.countryList.find(x => x.isdefault)?.id || this.countryList[0].id;
        }

        this.phoneNumberValue = ctrVal.number;
        this.phoneCountryId = ctrVal.countryId;

        if (ctrVal.changed) {
          this.setFieldControlValue();
        }
      }, 100);
    })
  }
  ngOnChanges(changes: any): void {
    if (changes.required) {
      this.validateNumber();
    }
  }

  getAllCountries() {
    this.countryLoading = true;
    this.lookupService.getCountries().subscribe((data: any) => {
      this.countryLoading = false
      this.countryList = data;

      if (!this.phoneCountryId) {
        this.phoneCountryId = this.countryList.find(x => x.isdefault)?.id || this.countryList[0].id;
        this.setFieldControlValue();
      } else {
        this.phoneCountryId = this.countryList.find(x => x.id == Number(this.selectedCountry))?.id;
        this.setFieldControlValue();
      }
    }, (err: any) => {
      console.error(err);
    });
  }

  validateNumber() {
    if (this.phoneNumberValue?.length) {
      if (this.phoneNumberValue.length > this.maxLength
        || this.phoneNumberValue.length < this.minLength
        || !this.phoneCountryId) {
        this.formGroup.controls[this.controlName].setErrors({ 'invalid': true })
      } else {
        this.formGroup.controls[this.controlName].setErrors(null)
      }
    } else {
      if (this.required) {
        this.formGroup.controls[this.controlName].setErrors({ 'required': true })
      }
      if (!this.required) {
        // this.formGroup.controls[this.controlName].setErrors({ 'required': false })
        this.formGroup.controls[this.controlName].setErrors(null)
      }
    }
  }

  setFieldControlValue() {
    this.validateNumber();
    if (this.formGroup.controls[this.controlName].valid) {
      if (this.phoneCountryId || this.phoneNumberValue) {
        this.formGroup.controls[this.controlName].setValue({
          number: this.phoneNumberValue,
          countryCode: this.phoneCountryId,
          dialCode: this.countryList.find(x => x.id == Number(this.phoneCountryId))?.countryKey
        });
      }
    }
    if (!this.phoneNumberValue) {
      this.formGroup.controls[this.controlName].setValue({
        number: this.phoneNumberValue,
        countryCode: this.phoneCountryId,
        dialCode: this.countryList.find(x => x.id == Number(this.phoneCountryId))?.countryKey
      });
      this.validateNumber();
      this.valueChanged.emit(true);
    }
    // this.phoneValueChanged();
  }

  hasError(errorName: string) {
    if (this.isSubmitted || this.isTouched) {
      if (this.phoneCountryId || this.phoneNumberValue) {
        if (!errorName) { return this.formGroup.controls[this.controlName].invalid; }
        else { return this.formGroup.controls[this.controlName].hasError(errorName); }
      }
      else {
        if (this.required && (!this.phoneCountryId || !this.phoneNumberValue)) {
          return true
        }
      }
    }
    return false;
  }

  phoneValueChanged(event: any = null) {
    if (event && !event.id) { event.preventDefault(); }
    if (this.phoneNumberValue) {
      this.valueChanged.emit(true)
    }
  }
  phoneInputBlur() {
    if (this.phoneNumberValue) {
      this.inputBlur.emit(true);
    }
  }
  modelChanged() {
    // this.validateNumber();
    // this.formGroup.controls[this.controlName].setValue({
    //   number: this.phoneNumberValue,
    //   countryCode: this.phoneCountryId,
    //   dialCode: this.countryList.find(x => x.id == Number(this.phoneCountryId))?.countryKey
    // });
    this.valueRemoved.emit(true);
  }

}
